import { EntryAddressStatusDetails } from "@globals/openapi-models/model/entryAddressStatusDetails";
import { Marker } from "leaflet";
import { BiMapComponentAddressModel } from "./BiMapComponentAddressModel";
import { IMapAddressHolder } from "./IMapAddressHolder";

export class BiMapMarker extends Marker implements IMapAddressHolder {
  address: EntryAddressStatusDetails | BiMapComponentAddressModel;
  /**
   * Leaflet layer ID (created using L.stamp()) referring to the Polygon or pin marker containing this marker.
   * Note: a pin marker must have a defined radius in order to contain other markers.
   */
  parentShapeId?: number;
  countryId?: number;
}
